<template>
  <el-form :inline="true" :model="form" class="filter-bar">
    <!-- 日期范围选择器 -->
    <el-form-item label="日期">
      <el-date-picker
        class="filter-date-picker"
        v-model="dates"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        @change="handleDateChange"
      />
    </el-form-item>

    <!-- 地区选择器 -->
    <!-- <el-form-item label="地区">
      <el-select v-model="form.area" placeholder="请选择地区" clearable @change="handleFieldChange('area', $event)">
        <el-option v-for="item in areaOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
    </el-form-item> -->

    <!-- 品类选择器 -->
    <!-- <el-form-item label="品类">
      <el-select v-model="form.c_name" placeholder="请选择品类" clearable @change="handleFieldChange('c_name', $event)">
        <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
    </el-form-item> -->

    <!-- 名称选择器 -->
    <el-form-item label="客户">
      <el-select v-model="form.user_name" placeholder="请选择客户" clearable @change="handleFieldChange('user_name', $event)">
        <el-option v-for="item in userOptions" :key="item.user_name" :label="item.user_name" :value="item.user_name" />
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'FilterBar',
  props: {
    // 地区选项 [{ label: '华东', value: 'east' }, ...]
    areaOptions: {
      type: Array,
      default: () => []
    },
    // 品类选项
    categoryOptions: {
      type: Array,
      default: () => []
    },
    // 用户选项
    userOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 日期范围绑定值，格式已经是 "yyyy-MM-dd"
      dates: [],
      form: {
        user_name: ''
      }
    }
  },
  watch: {
    // 当任何筛选字段改变时，触发接口请求
    form: {
      deep: true,
      handler() {
      // this.emitSearch()
      this.byUserSearch()

      }
    },
    dates() {
      this.emitSearch()
    }
  },
  methods: {
    // 日期变化处理，el-date-picker 的 change 会传入 value
    handleDateChange(value) {
      this.dates = value || []
      // watch 会自动触发，这里也可以手动调用
    },
    // 下拉选择变化处理
    handleFieldChange(field, value) {
      this.form[field] = value
      // watch 的 deep 监听会自动调用 emitSearch
    },
    // 组合参数并向外发送
    emitSearch() {
      const params = {
        date_start: this.dates?.[0] || '',
        date_end: this.dates?.[1] || '',
        // user_name: this.form.user_name || ''
      }
      this.$emit('search', params)
    },
    byUserSearch() {
      const params = {
        // date_start: this.dates?.[0] || '',
        // date_end: this.dates?.[1] || '',
        user_name: this.form.user_name || ''
      }
      this.$emit('byUserSearch', params)
    },
  }
}
</script>

<style lang="less" scoped>
.el-form.filter-bar {
  // width: 100%;
  /deep/.el-form-item {
    .el-form-item__label {
      font-size: 14px;
      color: #fff;
    }

    .el-select {
      .el-input__inner {
        background-color: #081c30;
        border: 1px solid #385576;
        color: #57708d;
        font-size: 14px;
      }
      .el-input {
        width: 180px;
      }
    }

    .filter-date-picker {
      background-color: #081c30;
      border-color: #385576;
      color: #57708d;
      font-size: 14px;
      .el-date-editor--datetimerange.el-input,
      .el-date-editor--datetimerange.el-input__inner {
        width: 280px;
      }

      .el-range-input {
        background-color: #081c30;
        color: #57708d;
      }

      .el-range-separator {
        width: initial;
        color: #57708d;
      }
    }
  }
}
</style>
